// Eerste element standaard openen
$('[data-toggle*="toggle-js"]').each(function() {
    $(this).find('*:first-child').addClass('active');
});

// Klikbaar maken van de toggle lijst
$('body').on('click', '[data-toggle*="toggle-js"] [data-toggle="title"]', function() {
    $(this).parent().toggleClass('active');
});
